import React, { useContext } from "react";
import { LangCtx, PayLoadCtx } from "../../../../lib/context";
import { Button } from "@material-ui/core";
import "../styles.css";
import { useHistory } from "react-router-dom";
import { dateFormat } from "../../../../lib/functions";

const ManageLicensesPack = (props) => {
    const { l } = useContext(LangCtx);
    const history = useHistory();
    const { payload } = useContext(PayLoadCtx);

    const handleBuyMore = () => {
        history.push(`/place-your-order/INVCCCP/5?username=${payload?.email}&subdomain=${payload?.subdomain}`);
    };

    const handleRenewal = () => {
        const no_of_licenses = props?.licenseData?.noOfLicenses;
        history.push(`/place-your-order/INVCCCP/${no_of_licenses}?username=${payload?.email}&subdomain=${payload?.subdomain}`);
    };

    const getRenewalDate = () => {
        let expiryDate = new Date(props?.licenseData?.to);
        let nextDate = expiryDate.setDate(expiryDate.getDate() + 1);
        return dateFormat(nextDate.valueOf());
    };

    const checkRenewalDate = () => {
        if (props?.licenseData && props?.licenseData?.to) {
            const expireDate = new Date(props?.licenseData?.to).setHours(0, 0, 0, 0);
            const currentDate = new Date().setHours(0, 0, 0, 0);
            const difference = expireDate - currentDate;
            const differenceInDays = Math.floor(difference / (1000 * 3600 * 24));
            if (differenceInDays <= 14) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    };

    return (
        <>
            <div className="flexRow pdngMD">
                <h2 className="uprCaseTxtMD">INVCCCP</h2>
                {/* <div className="flexAuto">
                        <Button variant="outlined" color="primary" size="small" disableElevation>
                            {language.roomSet_manage_licenses}
                        </Button>
                </div> */}
            </div>
            <div className="resColRow pdngHztlMD pdngBtmMD borderBtm">
                <div className="flexInline mrgnRMD">
                    <span className="reltvDateTxtSM pastTxt">
                        {l.purchased_on}:<span className="reltvDateTxtSMB">{dateFormat(props?.licenseData?.from)}</span>
                    </span>
                </div>
                <div className="flexInline">
                    <span className="reltvDateTxtSM featureTxt">
                        {l.expires_on}:<span className="reltvDateTxtSMB">{dateFormat(props?.licenseData?.to)}</span>
                    </span>
                </div>
            </div>

            <div className="resColRow pdngMD">
                <div className="flexMinWidthCol">
                    <span className="reltvDateTxtSM">
                        {l.products}:<span className="reltvDateTxtSMB">inClinic</span>
                    </span>
                    <span className="reltvDateTxtSM">
                        {l.renews_on}:<span className="reltvDateTxtSMB"> {getRenewalDate()}</span>
                    </span>
                    <span className="reltvDateTxtSM">
                        {l.no_of_licenses}:<span className="reltvDateTxtSMB">{props?.licenseData?.noOfLicenses}</span>
                    </span>
                </div>

                {/* <div className="flexAuto resPdngTop alignCntr">
                    <Button fullWidth variant="contained" color="primary" disableElevation size="small" onClick={handleBuyMore}>
                        {l.buy_more}
                    </Button>
                </div> */}
                {payload?.expiryAt <= props?.licenseData?.to ? (
                    <div className="flexAuto resPdngTop alignCntr">
                        {checkRenewalDate() ? (
                            <Button fullWidth variant="contained" color="primary" className='whiteTxt' disableElevation size="small" onClick={handleRenewal}>
                                {l.renewal}
                            </Button>
                        ) : (
                            <Button fullWidth variant="contained" color="primary" className='whiteTxt' disableElevation size="small" onClick={handleBuyMore}>
                                {l.buy_more}
                            </Button>
                        )}
                    </div>
                ) : (
                    <div>Your License has been renewed</div>
                )}
            </div>
        </>
    );
};

export default ManageLicensesPack;
